import React from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { Image } from "@mantine/core";

const useStyles = makeStyles((theme) => ({
  person: {
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    gap: ".8rem",
    "@media screen and (max-width: 768px)": {
      padding: 0,
    },
  },
  textWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  name: {
    fontSize: "0.875rem !important",
    color: theme.app.contrastLabelColor,
    fontWeight: 500,
    wordBreak: "break-word",
  },
  mail: {
    fontSize: "0.75rem !important",
    color: theme.app.secondaryColor,
    fontWeight: 500,
    wordBreak: "break-word",
  },
}));

const ActivePerson = ({ data, language }) => {
  const classes = useStyles();

  return (
    <div className={classes.person}>
      <Image
        width={40}
        height={40}
        withPlaceholder
        radius="xl"
        src={data?.photo}
        alt={`${data?.name} ${language?.Pages?.photo.toLowerCase()}`}
      />
      <div className={classes.textWrapper}>
        <Typography className={classes.name}>{data?.name}</Typography>
        <Typography className={classes.mail}>{data?.email}</Typography>
      </div>
    </div>
  );
};

export default ActivePerson;
